import { render, staticRenderFns } from "./accounts-receivable-summary-detail.vue?vue&type=template&id=44a2d4a8&scoped=true"
import script from "./accounts-receivable-summary-detail.vue?vue&type=script&lang=js"
export * from "./accounts-receivable-summary-detail.vue?vue&type=script&lang=js"
import style0 from "./accounts-receivable-summary-detail.vue?vue&type=style&index=0&id=44a2d4a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a2d4a8",
  null
  
)

export default component.exports